import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTriangleExclamation, faSnowflake } from "@fortawesome/pro-solid-svg-icons"
import { SyncOutlined } from "@ant-design/icons"
import { TaskCalendarEvent } from "./scheduleApi"
import { EventWarning } from "./scheduleModel"

type Props = {
  event: TaskCalendarEvent
  warning?: EventWarning
}

const TaskPopoverContent = ({ event, warning }: Props) => {
  return (
    <div style={{ maxWidth: 280 }}>
      {event.frozen && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 8px', marginBottom: 8, backgroundColor: '#e6f4ff', border: '1px solid #91caff', borderRadius: 4 }}>
          <FontAwesomeIcon icon={faSnowflake} style={{ color: '#0958d9', fontSize: 12, flexShrink: 0 }} />
          <span style={{ fontSize: 12, color: '#0958d9' }}>Frozen — cannot be rescheduled</span>
        </div>
      )}
      {warning && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 8px', marginBottom: 8, backgroundColor: '#fff7e6', border: '1px solid #ffd591', borderRadius: 4 }}>
          <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: '#fa8c16', fontSize: 12, flexShrink: 0 }} />
          <span style={{ fontSize: 12, color: '#ad6800' }}>{warning.message}</span>
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ fontWeight: 600 }}>{event.title}</span>
        {event.repeatingId && (
          <SyncOutlined style={{ color: '#999', fontSize: '12px' }} />
        )}
      </div>
      {event.notes && (
        <div style={{ color: "#666", fontSize: 13, marginTop: 4 }}>
          {event.notes.length > 200 ? <>{event.notes.slice(0, 200)}&hellip;</> : event.notes}
        </div>
      )}
    </div>
  )
}

export default TaskPopoverContent
